<script>
  // @ts-check
  import { createEventDispatcher } from "svelte";

  import Button from "../../atoms/Button.svelte";
  import Icon from "../../atoms/Icon.svelte";

  import SearchInput from "./SearchInput.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = undefined;

  /** Search ID
   * @type {string} */
  export let searchId = undefined;

  /** Selected value of the search input
   * @type {string} */
  export let selectedValue = null;

  /** The `autocomplete` prop determines whether the browser should automatically complete the input value.
   * @type {string | undefined} */
  export let autocomplete = undefined;

  /** Field should be focused on mount
   * @type {boolean} */
  export let focusOnMount = false;

  /**
   * An optional CSS class to be applied to the component.
   * @type {string}
   */
  let componentClass = "";
  export { componentClass as class };

  const dispatch = createEventDispatcher();

  const onSubmit = (event) => {
    const formData = new FormData(event.target);
    const formValues = Object.fromEntries(formData);
    dispatch("submit", formValues);
  };
</script>

<form {id} role="search" class="relative {componentClass}" on:submit|preventDefault={onSubmit}>
  <SearchInput
    id={searchId}
    label="Search"
    on:clear
    on:change
    on:input
    {selectedValue}
    {autocomplete}
    {focusOnMount}
    required
  />
  <div class="!absolute bottom-8 right-0 lg:bottom-9 xl:bottom-10">
    {#if $$slots.submitButton}
      <slot name="submitButton" />
    {:else}
      <Button
        type="submit"
        variant="filled"
        theme="white"
        ariaLabel="Submit"
        buttonClass="h-[48px] w-[48px]"
      >
        <Icon slot="icon" name="arrowRight" />
      </Button>
    {/if}
  </div>
</form>
